import type { HeroContent } from "../types";

export const hero: HeroContent = {
  newsbarAriaLabel: "Platformopdateringer",
  newsLabel: "OPSTART · 14. SEPTEMBER 2026",
  newsItems: [
    "UCloud AI går live for alle 25.000 brugere af den nationale forskningsplatform",
    "Din forskning er aldrig træningsdata. Hver token beregnes i Danmark",
    "Førende åbne internationale modeller fra dag ét. Danske modeller er på vej",
    "Chat og OpenAI-kompatibelt API, lige inde i dit UCloud-projekt",
    "Kører på Bitten i Sønderborg – energieffektiv beregning, varmegenvinding",
    "Fra login til første token på fem minutter. Suveræn AI, ét login væk",
  ],
  eyebrowLead: "Præsenterer",
  eyebrowName: "UCloud AI",
  titleLead: "Suveræn AI til <br>dansk",
  titleAccent: "forskning.",
  titleSub: "Din forskning er aldrig træningsdata.",
  subtitle:
    "Kør store sprogmodeller på dine egne data, i dit eksisterende " +
    "UCloud-projekt, med dit universitetslogin. Hver token beregnes i " +
    "Danmark, og dine data bruges aldrig til træning.",
  ctaPrimary: "Prøv det",
  ctaSecondary: "Kontakt os",
  finePrint: "Kører på Bitten, Sønderborg · open source (EUPL) · ISO/IEC 27001:2022",
  finePrintSecondary: "Mulighed for opskalering til AI-supercomputeren Gefion",
};
